module.exports = __webpack_public_path__ + "img/font_english111-vivace-bt.cac3348.svg";